//@flow

import type {ClearancePrice} from "./clearanceTypes";


export  async function fetchClearanceProducts(productCodes:number[] ) {
  return await (await window.fetch(
      `/search/products/clearance/batch?productCodes=${productCodes.join(
          ","
      )}`
  )).json();
}



export  async function fetchClearanceProductPrices(productCodes:number[] ): Promise<{ [productId: number]: ClearancePrice }> {
    return await ( await fetch(`/search/products/clearance/prices/batch?productCodes=${productCodes.join(
        ","
    )}`, {
        credentials: "include",
    })).json();

}





// WEBPACK FOOTER //
// ./javascript/product-search-page/clearance/fetchClearanceProducts.js